import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from '@mui/material';
import { Department } from '../../api/api-generated';
import { useFindAllHardwareQuery } from '../../api/api-hooks';
import { useHardwareTypeMap } from '../../hooks/useHardwareTypeMap';
import { useSoftwareTypeMap } from '../../hooks/useSoftwareTypeMap';
import { hasDatePassed } from '../../utils/dateTime';

interface Props {
  department: Department;
}

const HardwareDisplayForDepartments = ({ department }: Props) => {
  const { data: allHardware } = useFindAllHardwareQuery({});
  const softwareTypeMap = useSoftwareTypeMap();
  const hardwareTypeMap = useHardwareTypeMap();
  if (allHardware === undefined || !hardwareTypeMap) return null;
  const rows: {
    serial: string;
    softwareType: string;
    unitType: string;
    expirationDate: string;
  }[] = [];
  for (const hardwareItem of department.hardware) {
    for (const license of hardwareItem.licenses) {
      const softwareType = softwareTypeMap.get(license.softwareId);
      const unitType = hardwareTypeMap.get(hardwareItem.hardwareTypeId);
      const { supportEndDate } = hardwareItem.supportPurchases.reduce(
        (acc, cur) => (acc.supportEndDate > cur.supportEndDate ? acc : cur),
        { supportEndDate: '' }
      );
      const newRow = {
        serial: hardwareItem.serial,
        softwareType: softwareType ? softwareType : '',
        unitType: unitType ? unitType : '',
        expirationDate: supportEndDate,
      };
      rows.push(newRow);
    }
  }
  const sortedRows = rows.sort((row1, row2) =>
    row1.serial.localeCompare(row2.serial)
  );
  if (department.hardware.length === 0)
    return (
      <Typography variant='body2'>
        No units associated with department.
      </Typography>
    );
  return (
    <TableContainer>
      <Table size='small' aria-label='hardware table'>
        <TableHead>
          <TableRow>
            <TableCell align='right'>Serial</TableCell>
            <TableCell align='right'>Software</TableCell>
            <TableCell align='right'>Expires</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedRows.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell align='right'>{row.serial}</TableCell>
              <TableCell align='right'>{row.softwareType}</TableCell>
              <TableCell align='right'>
                <Typography
                  variant='body2'
                  color={
                    hasDatePassed(new Date(row.expirationDate))
                      ? 'red'
                      : undefined
                  }
                >
                  {row.expirationDate
                    ? new Date(row.expirationDate).toDateString()
                    : 'No support plan'}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default HardwareDisplayForDepartments;
